<template>
    <div class="modal-container">
        <div class="modal fade show" :class="{'modal-open': isOpen}" aria-modal="true" role="dialog">
            <div class="modal-overlay" @click="isOpen = false"></div>
            <div class="modal-dialog" :class="[{'modal-xxl': large}, {'modal-fullscreen-xxl-down': fullscreen}]">
                <div class="modal-content">
                    
                        <div class="modal-header" v-if="!headerDisable">
                            <h4 class="modal-title"><slot name="title"></slot></h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="isOpen = false">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <slot name="body"></slot>
                        </div>
                        <div class="modal-footer justify-content-between" v-if="!footerDisable">
                            <slot name="footer"></slot>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import screenMixin from '@/mixins/screen'

export default {
    name: 'BaseModal',
    mixins: [
        screenMixin
    ],
    props: {
        title: {
            type: String,
            default: 'Title'
        },
        large: {
            type: Boolean,
            default: false
        },
        fullscreen: {
            type: Boolean,
            default: false
        },
        headerDisable: {
            type: Boolean,
            default: false
        },
        footerDisable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            isMobile: false
        };
    },
    methods: {
        open() {
            this.isOpen = true;
        },
        close() {
            this.isOpen = false;
        }
    },
    watch: {
        isOpen: function (val) {
            if(val)
                document.body.style.overflow = 'hidden';
            else if(!(this.$el.classList.contains('room-modal-xxl') && this.isMobile && this.$route.name == 'wizard'))
                document.body.style.overflow = 'auto';
        },
        isMobile() {
            if(!(this.$el.classList.contains('room-modal-xxl') && this.$route.name == 'wizard'))
                return;

            if(this.isOpen)
                document.body.style.overflow = 'hidden';
        }
    },
    beforeMount() {
        const self = this;
        window.addEventListener('resize', function () {
            self.isMobile = self.isBreakpoint('xs') || self.isBreakpoint('sm');
        });
        self.isMobile = self.isBreakpoint('xs') || self.isBreakpoint('sm');
    },
};
</script>

<style scoped>
.modal-open{
    display: block;
}
.modal-overlay{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--bs-gray-900);
    opacity: .7;
}
.modal-body{
    max-height: calc(100vh - 200px);
    overflow-y: auto;
}
.modal-xxl{
    max-width: 96vw;
}

@media (max-width: 1400px){
    .modal-xxl.modal-fullscreen-xxl-down {
        max-width: none;
    }
}
</style>
